import React from 'react';
import MUITextField from '@mui/material/TextField';
import Error from './Error.component';
import { useController, useFormContext } from 'react-hook-form';
import { Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import PropTypes from 'prop-types';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

const TimePickerComponent = ({ name, required, label }) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    const {
        field: { ref, onChange, value = null, ...inputProps },
    } = useController({
        name: name,
        control: control,
        rules: { required },
    });

    const parsedValue = (() => {
        if (!value) {
            return null;
        }

        if (dayjs.isDayjs(value)) {
            return value.isValid() ? value : null;
        }

        if (typeof value === 'string') {
            const strictTime = dayjs(value, 'HH:mm:ss', true);
            if (strictTime.isValid()) {
                return strictTime;
            }

            const genericParsed = dayjs(value);
            return genericParsed.isValid() ? genericParsed : null;
        }

        const dateLikeParsed = dayjs(value);
        return dateLikeParsed.isValid() ? dateLikeParsed : null;
    })();

    return (
        <Box display='flex' flexDirection={'column'}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                    ref={ref}
                    {...inputProps}
                    label={label}
                    inputFormat='HH:mm'
                    value={parsedValue}
                    onChange={(newValue) =>
                        onChange(
                            newValue && dayjs(newValue).isValid()
                                ? dayjs(newValue).format('HH:mm:ss')
                                : null
                        )
                    }
                    renderInput={(params) => (
                        <MUITextField {...params} required={required} error={!!errors[name]?.message} />
                    )}
                    ampm={false}
                />
            </LocalizationProvider>
            <Error error={errors[name]?.message} />
        </Box>
    );
};

TimePickerComponent.propTypes = {
    name: PropTypes.string,
    required: PropTypes.bool,
    label: PropTypes.string,
    disableFuture: PropTypes.bool,
    disablePast: PropTypes.bool,
};

export default TimePickerComponent;
